<span class="label"><span class="dot"></span><ng-content></ng-content></span>
@if (problem()) {
    <span [title]="problem()" class="problem">{{ problem() }}</span>
}
